import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledPrivacyIcon = styled.svg<IconProps>`
  & .cls-1,
  .cls-3 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
    fill-rule: evenodd;
  }

  & .cls-3 {
    stroke: var(--chatbot-color-primary, #404040);
  }

  & .cls-4 {
    stroke: none;
  }
`;

const PrivacyIcon: React.FC<IconProps> = props => {
  const activeclass = props.active ? 'active' : undefined;
  return (
    <StyledPrivacyIcon
      id='Privacy-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='Privacy' transform='translate(6.5 0.5)'>
        <rect id='Margin' className='cls-1' width='32' height='32' transform='translate(-6.5 -0.5)' />
        <g id='Icon' transform='translate(-1 3)'>
          <path
            id='Path_15945'
            data-name='Path 15945'
            className='cls-2'
            d='M11.5,12.5a1,1,0,1,0,1,1A1,1,0,0,0,11.5,12.5Zm-2,1a2,2,0,1,1,2,2A2,2,0,0,1,9.5,13.5Z'
            transform='translate(-1 -0.5)'
          />
          <path
            id='Path_15946'
            data-name='Path 15946'
            className='cls-2'
            d='M9.05,17.5h4.9a2.5,2.5,0,0,0-4.9,0ZM8,18a3.5,3.5,0,0,1,7,0,.5.5,0,0,1-.5.5h-6A.5.5,0,0,1,8,18Z'
            transform='translate(-1 -0.5)'
          />
          <g id='Rectangle_7250' data-name='Rectangle 7250' className='cls-3' transform='translate(4.5 8.5)'>
            <rect className='cls-4' width='12' height='12' />
            <rect className='cls-1' x='0.5' y='0.5' width='11' height='11' />
          </g>
          <g id='Rectangle_7251' data-name='Rectangle 7251' className='cls-3' transform='translate(6.5 4.5)'>
            <path className='cls-4' d='M3,0H5A3,3,0,0,1,8,3V5A0,0,0,0,1,8,5H0A0,0,0,0,1,0,5V3A3,3,0,0,1,3,0Z' />
            <path
              className='cls-1'
              d='M3,.5H5A2.5,2.5,0,0,1,7.5,3V4.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V3A2.5,2.5,0,0,1,3,.5Z'
            />
          </g>
        </g>
      </g>
    </StyledPrivacyIcon>
  );
};

export default PrivacyIcon;
